import { api } from '../core';

type ReorderChronologyEntriesResponse = Record<string, never>;

interface ReorderChronologyEntriesProps {
  abortController?: AbortController;
  entryId: string;
  targetEntryId: string;
  position: 'before' | 'after';
}

const chronologyEntriesReorderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    reorderChronologyEntries: builder.mutation<ReorderChronologyEntriesResponse, ReorderChronologyEntriesProps>({
      query: ({
        abortController = new AbortController(),
        entryId,
        targetEntryId,
        position
      }: ReorderChronologyEntriesProps) => ({
        url: 'chronology/entries/reorder',
        method: 'POST',
        body: {
          entry_id: entryId,
          target_entry_id: targetEntryId,
          position
        },
        signal: abortController.signal
      }),
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components
 */
export const { useReorderChronologyEntriesMutation } = chronologyEntriesReorderApi;
